/* eslint-disable */
import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars-2";

const Sidebar = () => {
  const [selectedItems, setSelectedItems] = useState(Array().fill(false));
  const { pathname } = useLocation();
  const user = window.CURRENT_USER;
  const handleItemClick = (index) => {
    setSelectedItems((prevSelectedItems) => {
      const updatedSelectedItems = [...prevSelectedItems];
      console.log("selectedItems", selectedItems);
      // Close the previously opened item
      updatedSelectedItems.forEach((item, i) => {
        if (i !== index) {
          updatedSelectedItems[i] = false;
        }
      });

      // Toggle the state of the clicked item
      updatedSelectedItems[index] = !updatedSelectedItems[index];

      return updatedSelectedItems;
    });
  };

  useEffect(() => {
    function handleMouseOver(e) {
      e.stopPropagation();
      if (
        document.body.classList.contains("mini-sidebar") &&
        document.querySelector("#toggle_btn").offsetParent !== null
      ) {
        var targ = e.target.closest(".sidebar");
        if (targ) {
          document.body.classList.add("expand-menu");
          document
            .querySelectorAll(".subdrop + ul")
            .forEach((ul) => (ul.style.display = "block"));
        } else {
          document.body.classList.remove("expand-menu");
          document
            .querySelectorAll(".subdrop + ul")
            .forEach((ul) => (ul.style.display = "none"));
        }
        return false;
      }
    }

    document.addEventListener("mouseover", handleMouseOver);

    return () => {
      document.removeEventListener("mouseover", handleMouseOver);
    };
  }, []);

  const handleLogout = async () => {
    try {
      const response = await fetch("/accounts/logout/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // "X-CSRFToken": getCookie("csrftoken"), // Only if using Django CSRF
        },
        credentials: "include", // needed for sending cookies if using session auth
      });

      if (response.ok) {
        window.location.reload();
      } else {
        console.error("Logout failed", await response.text());
      }
    } catch (error) {
      console.error("Logout error", error);
    }
  };
  return (
    <>
      <div className="sidebar" id="sidebar">
        <Scrollbars>
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul className="sidebar-vertical">
                {/* Main */}
\                {user?.user_role === "super_admin" && (
                <li>
                  <Link
                    className={pathname === "/dashboard/" ? "active" : ""}
                    to="/dashboard"
                  >
                    <i className="fe fe-box" />

                    <span>Dashboard</span>
                  </Link>
                </li>
                )}
                {user?.user_role === "super_admin" && (
                  <>
                    <li className="menu-title">
                      <span>Customers</span>
                    </li>
                    <li>
                      <Link
                        to="/customers"
                        className={pathname === "/customers" ? "active" : ""}
                      >
                        <i className="fe fe-users" /> <span>Customers</span>
                      </Link>
                    </li>
                  </>
                )}
                {/* {user?.user_role !== "customer" && (
                  <>
                    <li className="menu-title">
                      <span>Inventory</span>
                    </li>
                    <li className="submenu">
                      <Link
                        to="#"
                        onClick={() => handleItemClick(4)}
                        className={selectedItems[4] ? "subdrop" : ""}
                      >
                        <i className="fe fe-package" /> <span> Products</span>{" "}
                        <span className="menu-arrow" />
                      </Link>
                      <ul
                        style={{ display: selectedItems[4] ? "block" : "none" }}
                      >
                        <li>
                          <Link
                            to="/products"
                            className={pathname === "/products" ? "active" : ""}
                          >
                            Product List
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/products/add-product"
                            className={
                              pathname === "/products/add-product"
                                ? "active"
                                : ""
                            }
                          >
                            Add New Product
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </>
                )} */}

                {/* Sales */}
                <li className="menu-title">
                  <span>Sales</span>
                </li>
                <li className="submenu">
                  <Link
                    to="/invoice/"
                    className={pathname === "/invoice/" ? "active" : ""}
                  >
                    <i className="fe fe-file" /> <span>Invoices</span>
                  </Link>
                </li>
                <li className="submenu">
                  <Link
                    to="/invoice/quotations/"
                    className={
                      pathname === "/invoice/quotations/" ? "active" : ""
                    }
                  >
                    <i className="fe fe-file" /> <span>Quotes</span>
                  </Link>
                </li>
                <li className="submenu">
                  <Link
                    to="/invoice/proforma-invoices/"
                    className={
                      pathname === "/invoice/proforma-invoices/" ? "active" : ""
                    }
                  >
                    <i className="fe fe-file" /> <span>Proforma</span>
                  </Link>
                </li>
                {user?.user_role === "super_admin" && (
                  
                  <li className="submenu">
                  <Link
                    to="/payments/"
                    className={pathname === "/payments/" ? "active" : ""}
                  >
                    <i className="fe fe-file" /> <span>Accounts</span>
                  </Link>
                </li>
                )}
                {user?.user_role === "super_admin" && (
                <li className="submenu">
                  <Link
                    to="/expenses/"
                    className={pathname === "/expenses/" ? "active" : ""}
                  >
                    <i className="fe fe-file" /> <span>Expenses</span>
                  </Link>
                </li>
                )}
                
                <li className="menu-title">
                  <span>Settings</span>
                </li>
                <li>
                  <Link
                    className={
                      pathname === "/accounts/settings/" ? "active" : ""
                    }
                    to="/accounts/settings/"
                  >
                    <i className="fe fe-settings" /> <span>Settings</span>
                  </Link>
                </li>
                <li>
                  <Link
                    className={pathname === "/login" ? "active" : ""}
                    onClick={handleLogout}
                    style={{ cursor: "pointer" }}
                  >
                    <i className="fe fe-power" /> <span>Logout</span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
    </>
  );
};
export default Sidebar;
